import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=06ada9d1&scoped=true"
import script from "./SidebarSearch.vue?vue&type=script&lang=js"
export * from "./SidebarSearch.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearch.vue?vue&type=style&index=0&id=06ada9d1&prod&lang=scss&scoped=true"
import style1 from "./SidebarSearch.vue?vue&type=style&index=1&id=06ada9d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ada9d1",
  null
  
)

export default component.exports